import { useState } from "react";
import TokenChart from "components/tokens/TokenChart";


const TokenTransfer = () => {
  const [tabIndex, setTabIndex] = useState(0);
  
  return (
    <div className="rounded-[10px] bg-gray-50 dark:bg-darkGrey p-5">
        <div className="flex justify-between items-center">
            <p className="text-large max-w-[85px] sm:max-w-none">Token transfer</p>
            <div>
            <div className="flex rounded-[8px] btn-group">
                <button className={`btn btn-tab ${tabIndex === 0 ? 'active' : ''}`} onClick={() => setTabIndex(0)}>7 Days</button>
                <button className={`btn btn-tab ${tabIndex === 1 ? 'active' : ''}`} onClick={() => setTabIndex(1)}>1 Month</button>
                <button className={`btn btn-tab ${tabIndex === 2 ? 'active' : ''}`} onClick={() => setTabIndex(2)}>3 Months</button>
            </div>
            </div>
        </div>
        <div className="min-h-[300px] mt-2.5">
            <TokenChart days={tabIndex === 0 ? 7 : (tabIndex === 1 ? 30 : 90)} />
        </div>
    </div>
  );
};

export default TokenTransfer;
